import React from 'react'

import Checkbox from '../../Checkbox/Checkbox'
import { Truncate } from '../../Truncate/Truncate'
import classNames from 'classnames'

const RenderOption = ({ isMulti, currentQuery, handleMultiSelectQuery, opt, handleSelectQuery, query }) => {
  const getCheckboxData = () => {
    let isOptionCheck = false
    const currentQueryValue = currentQuery.value[0]

    let disabled = false
    if (currentQueryValue) {
      if (currentQueryValue.value[0] && currentQueryValue.value[0].value === '$any') {
        isOptionCheck = true
        disabled = opt.value === '$any' ? false : true
      } else {
        isOptionCheck = currentQueryValue.value.find((v) => v.value === opt.value)
      }
    }
    return { isOptionCheck, disabled }
  }
  if (isMulti) {
    const { isOptionCheck, disabled }: any = getCheckboxData()
    return (
      <li
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleMultiSelectQuery(opt, !isOptionCheck)
          }
        }}
        tabIndex={0} className="AdvancedQueryView__suggestion-item  AdvancedQueryView__suggestion-item--selectable AdvancedQueryView__suggestion-item--withCheckbox" data-test-id="cs-advance-search-select-list-element">
        <Checkbox
          testId="cs-advance-search-select-list-element-checkbox"
          checked={isOptionCheck || false}
          disabled={disabled}
          onChange={(e) => {
            handleMultiSelectQuery(opt, e.target.checked)
          }}
          label={opt.label}
        />
      </li>
    )
  }

  if (opt?.group) {
    return (
      <li
        className={classNames(
          'AdvancedQueryView__suggestion-item--heading',
        )}
        style={{ marginLeft: query?.nestingLevel ? `${query.nestingLevel * 10}px` : '' }}>
        {opt.group}
      </li>
    )
  }

  const isWorkflowStage = currentQuery.queryType === "workflowLabel";
  return (
    <li
      className="AdvancedQueryView__suggestion-item AdvancedQueryView__suggestion-item--selectable"
      onClick={() => {
        handleSelectQuery(query.queryType, opt)
      }}
      data-test-id="cs-advance-search-select-list-element"
      tabIndex={0}
    >
      <div style={{ marginLeft: isWorkflowStage ? `20px` : opt.nestingLevel ? `${opt.nestingLevel * 10}px` : '' }}>
        <Truncate isResponsive={true} truncateFrom="end" testId="cs-advance-search-select-list-element-label">
          {opt.type === 'text' ? `"${opt.label}"` : opt.label}
        </Truncate>
      </div>
    </li>
  )
}

export default RenderOption
